import api from 'app/api';
import store from 'app/store';

export const getEventList = async (params, callback) => {
  const {
    searchText,
    page_no,
    page_size,
  } = params;

  const successCallback = (data) => {
    const eventList = (data).map((item) => ({
      ...item,
      ...item?.payload,
    }));
    store.dispatch({ type: 'ADMIN_PRIMARY_RESCHEDULED_EVENT_LIST:DATA:SET', data: { data: eventList, totalPages: data?.pagination?.total_pages || 1 } });
    if (callback) callback(data);
  };

  
  await api.get(
    `/events/rescheduled/`,
    {
      id: 'reschedule-event',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params:     {
        page_no: page_no ? (page_no - 1) : 0,
        page_size: page_size || 10,
        searchText: searchText || '',
      },
    },
  );
};
